import { serverResponse } from 'app'

import * as actions from '../../actions/biosecurity'

export const getBiosecInitialState = () => serverResponse()

export default (state = getBiosecInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TRN_BIOSEC_FETCH: {
      return {
        ...getBiosecInitialState(),
        id: action.payload.tournamentId,
        loading: true,
      }
    }

    case actions.TRN_BIOSEC_FETCH_CANCELED: {
      return {
        ...state,
        ...action.payload,
        id: null,
        loaded: false,
        loading: false,
      }
    }
    case actions.TRN_BIOSEC_FETCH_ERROR:
    case actions.TRN_BIOSEC_FETCH_FULFILLED: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_BIOSEC_RESET: {
      return getBiosecInitialState()
    }

    default:
  }
  return state
}
